import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  loading?: HTMLIonLoadingElement;
  isDismissed = false;

  constructor(private loadingController: LoadingController) {}

  setLoading = async (loading: boolean) => {
    if (loading) {
      if (!this.loading) {
        // if this.loading, we are already showing a loading and nothing needs to be done
        await this.loadingController.create().then((element) => {
          if (!this.loading) {
            this.loading = element;
            element.onDidDismiss().then(() => {
              this.loading = undefined;
              this.isDismissed = false;
            });
          } else {
            // if loading has been created while creating this element, dismiss this element
            element.dismiss();
          }
          return element;
        });
        await this.loading.present().then(() => {
          if (this.isDismissed) {
            // if dismissing was called while we were creating the loading element
            this.loading.dismiss();
            this.isDismissed = false;
          }
        });
      }
    } else {
      if (this.loading) {
        await this.loading.dismiss();
      } else {
        this.isDismissed = true;
      }
    }
  };
}
